module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.fep.id) ? _c('vue-headful', {
    attrs: {
      "title": 'SGP - FEP ' + _vm.fep.id
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-header ng-scope"
  }, [(_vm.fep) ? _c('h1', [_vm._v("Ficha de Enquadramento de Projetos  -  FEP  Nº  " + _vm._s(_vm.fep.ano) + "/" + _vm._s(_vm.fep.numero) + "\n      "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "title": '<h5>Gera a FEP abaixo de forma resumida em Excel</h5>'
    }
  }, [_c('download-excel', {
    attrs: {
      "data": _vm.json_data,
      "meta": _vm.json_meta,
      "type": "xls",
      "fields": _vm.json_fields,
      "name": _vm.fepExcel
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/cadastro/fep'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Validação',
        href: '/'
      }, {
        text: 'Propostas',
        href: '#'
      }, {
        text: 'FEP',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "relatorio_fep"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "fep_titulo"
  }, [_c('div', [_vm._v("Ficha de Enquadramento de projetos")]), _vm._v(" "), (_vm.fep.id) ? _c('div', [_vm._v("FEP - Nº "), _c('span', {
    staticClass: "ressaltar titulo"
  }, [_vm._v(" " + _vm._s(_vm.fep.ano) + "/" + _vm._s(_vm.fep.numero))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome projeto')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.nome_projeto),
      expression: "fep.nome_projeto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome projeto",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.fep.nome_projeto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "nome_projeto", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome projeto')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Proponente")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome entidade')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.nome_entidade),
      expression: "fep.nome_entidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome entidade",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.fep.nome_entidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "nome_entidade", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome entidade')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('cnpj_entidade')
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cnpj_entidade",
      "mask": "##.###.###/####-##",
      "type": "text",
      "maxlength": "20"
    },
    model: {
      value: (_vm.fep.cnpj_entidade),
      callback: function($$v) {
        _vm.$set(_vm.fep, "cnpj_entidade", $$v)
      },
      expression: "fep.cnpj_entidade"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cnpj_entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj_entidade')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v(" Ano da Fep")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Ano Fep')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ano),
      expression: "fep.ano"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:4'),
      expression: "'required|max:4'"
    }],
    attrs: {
      "type": "number",
      "name": "Ano Fep",
      "min": "1901"
    },
    domProps: {
      "value": (_vm.fep.ano)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "ano", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Ano Fep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Ano Fep')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v(" Número da Fep")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Numero Fep')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.numero),
      expression: "fep.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:3'),
      expression: "'required|max:3'"
    }],
    attrs: {
      "type": "number",
      "name": "Numero Fep",
      "min": "0"
    },
    domProps: {
      "value": (_vm.fep.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "numero", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Numero Fep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Numero Fep')))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Projeto Duplicação')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.nr_projeto_duplicacao),
      expression: "fep.nr_projeto_duplicacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto Duplicação",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "nr_projeto_duplicacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5004"
    }
  }, [_vm._v("5004 / ADMINISTRATIVOS (INTERNOS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5006"
    }
  }, [_vm._v("5006 / COMUNICACAO INSTITUCIONAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5012"
    }
  }, [_vm._v("5012 / CONV. MESA/GM 055/2003 - 402258-0 - ENCERRADO 21-11-2008")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5013"
    }
  }, [_vm._v("5013 / CONV. MTE/GM 01/03 - 402.252-1 - ENCERRADO 31.7.2008")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5014"
    }
  }, [_vm._v("5014 / CONV. MTE/SE 01/02 - 56.569-5 - ENCERRADO/CONCLUÍDO 29-12-2005")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5015"
    }
  }, [_vm._v("5015 / CONV MTE/SENAES 15/2004 - 402.265-3 - ENCERRADO EM 31/12/2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5016"
    }
  }, [_vm._v("5016 / CONV. MTUR/Embratur 120/2003 - 402259-9 - ENCERRADO EM 26-12-2008")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5017"
    }
  }, [_vm._v("5017 / CONV MTUR 010/03 - 402.255-6 - ENCERRADO EM 31/12/2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5018"
    }
  }, [_vm._v("5018 / CONV. MDS/SAIP 004/2005 - 405314-1 - ENCERRADO EM 27-12-2007")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5020"
    }
  }, [_vm._v("5020 / ASSISTÊNCIA SOCIAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5021"
    }
  }, [_vm._v("5021 / DIVERSIDADE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5022"
    }
  }, [_vm._v("5022 / OUTROS PROJETOS - ASSISTÊNCIA SOCIAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5024"
    }
  }, [_vm._v("5024 / BANCO DE TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5025"
    }
  }, [_vm._v("5025 / BIO CONSCIÊNCIA ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5026"
    }
  }, [_vm._v("5026 / OUTROS PROJETOS - CIÊNCIA E TECNOLOGIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5030"
    }
  }, [_vm._v("5030 / PROJETO MEMÓRIA - MECENATO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5033"
    }
  }, [_vm._v("5033 / AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5034"
    }
  }, [_vm._v("5034 / BANCO NA ESCOLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5035"
    }
  }, [_vm._v("5035 / BB EDUCAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5036"
    }
  }, [_vm._v("5036 / ESCOLA CAMPEÃ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5037"
    }
  }, [_vm._v("5037 / INCLUSÃO DIGITAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5038"
    }
  }, [_vm._v("5038 / EDUCAÇÃO - PROJETOS INDEPENDENTES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5040"
    }
  }, [_vm._v("5040 / CRIANÇA E VIDA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5041"
    }
  }, [_vm._v("5041 / OUTROS PROJETOS - SAÚDE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5045"
    }
  }, [_vm._v("5045 / CADEIAS-APICULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5046"
    }
  }, [_vm._v("5046 / CADEIAS-ARTESANATO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5047"
    }
  }, [_vm._v("5047 / CADEIAS-BIODIESEL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5048"
    }
  }, [_vm._v("5048 / CADEIAS-CAJUCULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5049"
    }
  }, [_vm._v("5049 / CADEIAS-OVINOCAPRINOCULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5050"
    }
  }, [_vm._v("5050 / CADEIAS-FRUTICULTURA TROPICAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5051"
    }
  }, [_vm._v("5051 / CADEIAS-MANDIOCULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5052"
    }
  }, [_vm._v("5052 / CADEIAS-RESÍDUOS SÓLIDOS ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5053"
    }
  }, [_vm._v("5053 / CADEIAS-OUTRAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5055"
    }
  }, [_vm._v("5055 / TEMÁTICOS-AGRICULTURA FAMILIAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5056"
    }
  }, [_vm._v("5056 / TEMÁTICOS-ÁGUA DOCE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5057"
    }
  }, [_vm._v("5057 / DRLS-BERIMBAU")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5058"
    }
  }, [_vm._v("5058 / TEMÁTICOS-HORTAS COMUNITÁRIAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5060"
    }
  }, [_vm._v("5060 / TEMÁTICOS-TECBOR - BORRACHA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5061"
    }
  }, [_vm._v("5061 / DRLS-VALE DO URUCUIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5059"
    }
  }, [_vm._v("5059 / TEMÁTICOS-INCUBADORAS DE COOPERATIVAS ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5062"
    }
  }, [_vm._v("5062 / TEMÁTICOS-OUTROS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5064"
    }
  }, [_vm._v("5064 / INDEPENDENTES-CONTRAP.FBB CONV.MESA/GM 055/2003")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5065"
    }
  }, [_vm._v("5065 / INDEPENDENTES-CONTRAP.FBB CONV.MTE/SENAES 15/2004")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5067"
    }
  }, [_vm._v("5067 / INDEPENDENTES-PROJ.TERRA CIDADÃ VILA VINTEM II")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5068"
    }
  }, [_vm._v("5068 / INDEPENDENTES-PROJETOS N")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15120"
    }
  }, [_vm._v("15120 / RP FBB PIS/BB - Agroindústria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17160"
    }
  }, [_vm._v("17160 / RM FBB INSTITUTO VOTORANTIM PTAC IV")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15123"
    }
  }, [_vm._v("15123 / RP FBB AGROINDúSTRIA VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15126"
    }
  }, [_vm._v("15126 / RP FBB PIS/BB - Resíduos Sólidos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15129"
    }
  }, [_vm._v("15129 / RP FBB RESíDUOS SóLIDOS VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15149"
    }
  }, [_vm._v("15149 / RM FBB BNDES RIO DOCE FS 2015 PTAC 06/2015 - Água")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17218"
    }
  }, [_vm._v("17218 / ACORDO COPASA PRO-MANANCIAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6013"
    }
  }, [_vm._v("6013 / TEMÁTICOS-DESENVOLVIMENTO DE ECONOMIA SOLIDARIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5158"
    }
  }, [_vm._v("5158 / DRLS-SÃO BARTOLOMEU")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8588"
    }
  }, [_vm._v("8588 / DRLS-PDTIS MATA DOS COCAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9370"
    }
  }, [_vm._v("9370 / RM FBB BNDES - CADEIAS - RESÍDUOS SÓLIDOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9372"
    }
  }, [_vm._v("9372 / RM FBB BNDES - CADEIAS - CAJUCULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9374"
    }
  }, [_vm._v("9374 / RM FBB BNDES - CADEIAS-MANDIOCULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8583"
    }
  }, [_vm._v("8583 / INDEPENDENTES-CONTRAPARTIDA FBB CONVÊNIO BID FUMIN BR - M1070")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5660"
    }
  }, [_vm._v("5660 / DRLS-OUTROS PROJETOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5661"
    }
  }, [_vm._v("5661 / TEMÁTICOS-VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5662"
    }
  }, [_vm._v("5662 / TEMÁTICOS-QUILOMBOLAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5668"
    }
  }, [_vm._v("5668 / CONVÊNIO MTE/SPPE/Codefat - 405.316-8 - ENCERRADO EM 31/12/2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5978"
    }
  }, [_vm._v("5978 / TEMÁTICOS-TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6004"
    }
  }, [_vm._v("6004 / INDEPENDENTES-OUTROS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5977"
    }
  }, [_vm._v("5977 / CADEIAS-AQUICULTURA E PESCA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6010"
    }
  }, [_vm._v("6010 / TEMÁTICOS-AGROECOLOGIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6558"
    }
  }, [_vm._v("6558 / REAPLICAÇÃO DE TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5144"
    }
  }, [_vm._v("5144 / DRLS-VALE DO RIO DOCE (WUF)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5160"
    }
  }, [_vm._v("5160 / CONV. MTE/SENAES 03/2007 - 405.319-2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5161"
    }
  }, [_vm._v("5161 / RM FBB BID-FUMIN-DRS OUTROS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5189"
    }
  }, [_vm._v("5189 / DRLS-NOVOS TERRITÓRIOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5190"
    }
  }, [_vm._v("5190 / INDEPENDENTES-CONTRAPARTIDA FBB CONVÊNIO MTE/SENAES 003/2007")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8934"
    }
  }, [_vm._v("8934 / ACORDO BNDES - 5.585-9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8940"
    }
  }, [_vm._v("8940 / INDEPENDENTES-CONTRAPARTIDA FBB CONVÊNIO BNDES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10675"
    }
  }, [_vm._v("10675 / RM FBB BNDES - TEMÁTICOS - AGRICULTURA FAMILIAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9460"
    }
  }, [_vm._v("9460 / RM FBB BNDES - TEMÁTICOS - DESENV. DE ECONOMIA SOLIDÁRIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9462"
    }
  }, [_vm._v("9462 / RM FBB BNDES - CADEIAS - ARTESANATO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9388"
    }
  }, [_vm._v("9388 / RM FBB BNDES-DRLS-PDTIS ENTORNOS DE GRANDES PROJETOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9393"
    }
  }, [_vm._v("9393 / RM FBB BNDES - REAPLICAÇÃO DE TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9376"
    }
  }, [_vm._v("9376 / RM FBB BNDES - CADEIAS - APICULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9380"
    }
  }, [_vm._v("9380 / RM FBB BNDES-DRLS-VALE DO URUCUIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9382"
    }
  }, [_vm._v("9382 / RM FBB BNDES-DRLS-VALE DO RIO DOCE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9384"
    }
  }, [_vm._v("9384 / RM FBB BNDES-DRLS-SÃO BARTOLOMEU")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9386"
    }
  }, [_vm._v("9386 / RM FBB BNDES-DRLS-PDTIS MATA DOS COCAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11214"
    }
  }, [_vm._v("11214 / RM FBB BNDES-DRLS-OUTROS PROJETOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11291"
    }
  }, [_vm._v("11291 / TEMÁTICOS-PROJETOS INOVADORES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11293"
    }
  }, [_vm._v("11293 / TEMÁTICOS-PRESERVAÇÃO DE BIOMAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11851"
    }
  }, [_vm._v("11851 / TEMÁTICOS-AGROEXTRATIVISMO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11671"
    }
  }, [_vm._v("11671 / RM FBB-BNDES - PROJETOS INDEPENDENTES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11595"
    }
  }, [_vm._v("11595 / RM FBB PETROBRAS CADEIAS - RESÍDUOS SÓLIDOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11745"
    }
  }, [_vm._v("11745 / RM FBB BNDES - DRLS NOVOS TERRITóRIOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12368"
    }
  }, [_vm._v("12368 / RM FBB BNDES-TEMÁTICOS-AGROEXTRATIVISMO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12390"
    }
  }, [_vm._v("12390 / RM FBB BNDES-TEMÁTICOS-AGROECOLOGIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12392"
    }
  }, [_vm._v("12392 / RM FBB BNDES-TEMÁTICOS-PROJETOS INOVADORES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12385"
    }
  }, [_vm._v("12385 / RM FBB BNDES-TEMÁTICOS-PROSPECÇÃO E PROJETOS INOVADORES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12371"
    }
  }, [_vm._v("12371 / RM FBB BNDES - ÁGUA DE PRODUÇÃO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12373"
    }
  }, [_vm._v("12373 / RM FBB BNDES-TEMÁTICOS-HORTAS COMUNITÁRIAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12375"
    }
  }, [_vm._v("12375 / RM FBB BNDES-TEMÁTICOS-INCUBADORAS DE COOPERATIVAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12377"
    }
  }, [_vm._v("12377 / RM FBB BNDES-TEMÁTICOS-TECBOR - BORRACHA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12379"
    }
  }, [_vm._v("12379 / RM FBB BNDES-TEMÁTICOS-OUTROS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12381"
    }
  }, [_vm._v("12381 / RM FBB BNDES-TEMÁTICOS-VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12383"
    }
  }, [_vm._v("12383 / RM FBB BNDES-TEMÁTICOS-QUILOMBOLAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12386"
    }
  }, [_vm._v("12386 / RM FBB BNDES-TEMÁTICOS-TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12439"
    }
  }, [_vm._v("12439 / RM FBB BNDES-CADEIAS-AQUICULTURA E PESCA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12366"
    }
  }, [_vm._v("12366 / RM FBB BNDES-TEMÁTICOS-PRESERVAÇÃO DE BIOMAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17278"
    }
  }, [_vm._v("17278 / RM FBB BNDES - Fundo Social PTAC 2013 - Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17293"
    }
  }, [_vm._v("17293 / RM FBB BNDES ECOFORTE REDES - FS 06/2015")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17360"
    }
  }, [_vm._v("17360 / INDEPENDENTES EDUCAÇÃO - MINISTÉRIO DA DEFESA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18102"
    }
  }, [_vm._v("18102 / RP ENCHENTES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18104"
    }
  }, [_vm._v("18104 / RC ENCHENTES ESPÍRITO SANTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18108"
    }
  }, [_vm._v("18108 / RC ENCHENTES MINAS GERAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15083"
    }
  }, [_vm._v("15083 / RP FBB OUTROS PROJETOS ÁGUA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15091"
    }
  }, [_vm._v("15091 / RM FBB BNDES Ecoforte Extrativismo - Fundo Amazônia 2014")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18118"
    }
  }, [_vm._v("18118 / RP COVID-19")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18120"
    }
  }, [_vm._v("18120 / RC COVID-19")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18122"
    }
  }, [_vm._v("18122 / RC COVID19-GOVERNO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18124"
    }
  }, [_vm._v("18124 / RC ALUÍZIO CAMPOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15034"
    }
  }, [_vm._v("15034 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15037"
    }
  }, [_vm._v("15037 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2011")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14819"
    }
  }, [_vm._v("14819 / RP FBB OUT PROJ AGROECOLOGIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14761"
    }
  }, [_vm._v("14761 / RP FBB  ECOFORTE REDES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15094"
    }
  }, [_vm._v("15094 / RP FBB PIS/BB - Demais Iniciativas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15096"
    }
  }, [_vm._v("15096 / RP FBB DEMAIS VOLUNTARIADO INTEGRAçãO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15098"
    }
  }, [_vm._v("15098 / BB EDUCAR INTEGRAÇÃO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15132"
    }
  }, [_vm._v("15132 / RP FBB PIS/BB - Água")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15135"
    }
  }, [_vm._v("15135 / RP FBB ÁGUA VOLUNTAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14279"
    }
  }, [_vm._v("14279 / RM FBB BNDES  OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14281"
    }
  }, [_vm._v("14281 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14283"
    }
  }, [_vm._v("14283 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO AMAZÔNIA 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14266"
    }
  }, [_vm._v("14266 / RP FBB ÁGUA BRASIL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14294"
    }
  }, [_vm._v("14294 / RP FBB CISTERNAS AVALIAÇÃO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14270"
    }
  }, [_vm._v("14270 / RM FBB BNDES ECOFORTE REDES - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14273"
    }
  }, [_vm._v("14273 / RM FBB BNDES ECOFORTE REDES - FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14275"
    }
  }, [_vm._v("14275 / RM FBB BNDES Ecoforte Extrativismo - Fundo Amazônia 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14277"
    }
  }, [_vm._v("14277 / RM FBB BNDES MUNICÍPIOS VERDES - FUNDO AMAZÔNIA 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14301"
    }
  }, [_vm._v("14301 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14307"
    }
  }, [_vm._v("14307 / RP FBB OUTROS PROJETOS AGROINDÚSTRIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14315"
    }
  }, [_vm._v("14315 / RM FBB PETROBRAS CATAFORTE II CAMINHÕES - 2010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14317"
    }
  }, [_vm._v("14317 / RM FBB BNDES OUTROS PROJETOS RESÍDUOS SÓLIDOS - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14290"
    }
  }, [_vm._v("14290 / RM FBB BNDES TERRAFORTE 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14292"
    }
  }, [_vm._v("14292 / RM FBB BNDES TERRAFORTE 2014")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14296"
    }
  }, [_vm._v("14296 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14298"
    }
  }, [_vm._v("14298 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO SOCIAL PTAC 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14302"
    }
  }, [_vm._v("14302 / RM FBB BNDES OUTROS PROJETOS ÁGUA - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14344"
    }
  }, [_vm._v("14344 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO AMAZÔNIA 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14324"
    }
  }, [_vm._v("14324 / RM FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14326"
    }
  }, [_vm._v("14326 / RM FBB BNDES OUTRAS INICIATIVAS FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14328"
    }
  }, [_vm._v("14328 / RM FBB BID FUMIN OUTRAS INICIATIVAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14330"
    }
  }, [_vm._v("14330 / RP FBB OUTRAS INICIATIVAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14311"
    }
  }, [_vm._v("14311 / RM FBB MTE SENAES 2013 CATFORTE III BASES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14313"
    }
  }, [_vm._v("14313 / RM FBB BNDES  CATAFORTE III ESCRITÓRIO - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14333"
    }
  }, [_vm._v("14333 / RM FBB BNDES DEMAIS INICIATIVAS DRS FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14335"
    }
  }, [_vm._v("14335 / RP FBB DEMAIS INICIATIVAS DRS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14337"
    }
  }, [_vm._v("14337 / RP FBB DEMAIS INICIATIVAS VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15272"
    }
  }, [_vm._v("15272 / OUTROS PROJETOS DE EDUCAçãO RIO DOCE - BNDES PTAC 06/2015")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14473"
    }
  }, [_vm._v("14473 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14474"
    }
  }, [_vm._v("14474 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2011")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14475"
    }
  }, [_vm._v("14475 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14476"
    }
  }, [_vm._v("14476 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14482"
    }
  }, [_vm._v("14482 / RM FBB BNDES OUTROS PROJETOS AGROINDúSTRIA - FUNDO SOCIAL PTAC 2010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14517"
    }
  }, [_vm._v("14517 / RP FBB OUTROS PROJETOS RESÍDUOS SÓLIDOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15211"
    }
  }, [_vm._v("15211 / RP FBB RIO DOCE - AGROECOLOGIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15213"
    }
  }, [_vm._v("15213 / RM FBB BNDES RIO DOCE - AGROECOLOGIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15217"
    }
  }, [_vm._v("15217 / RP FBB RIO DOCE - AGROINDúSTRIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15219"
    }
  }, [_vm._v("15219 / RM FBB BNDES RIO DOCE - AGROINDúSTRIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15222"
    }
  }, [_vm._v("15222 / RP FBB RIO DOCE - RESíDUOS SóLIDOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15224"
    }
  }, [_vm._v("15224 / RM FBB BNDES RIO DOCE - RESíDUOS SóLIDOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15160"
    }
  }, [_vm._v("15160 / OUTROS PROJETOS DE EDUCAçãO - Rio Doce")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14749"
    }
  }, [_vm._v("14749 / RM FBB BNDES JUVENTUDE RURAL - FUNDO SOCIAL 2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14519"
    }
  }, [_vm._v("14519 / RM FBB BNDES ÁGUA BRASIL - FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14522"
    }
  }, [_vm._v("14522 / RP FBB PNHU")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14540"
    }
  }, [_vm._v("14540 / RM FBB BNDES Outros Projetos Resíduos Sólidos - Fundo Social PTAC 2010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14509"
    }
  }, [_vm._v("14509 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15114"
    }
  }, [_vm._v("15114 / RP FBB PIS/BB - Agroecologia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15117"
    }
  }, [_vm._v("15117 / RP FBB AGROECOLOGIA VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15141"
    }
  }, [_vm._v("15141 / EDUCAÇÃO - PROJETOS INDEPENDENTES - PIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15143"
    }
  }, [_vm._v("15143 / EDUCAÇÃO - PROJETOS INDEPENDENTES - VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15146"
    }
  }, [_vm._v("15146 / ÁGUA - RIO DOCE - RP FBB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15233"
    }
  }, [_vm._v("15233 / RP FBB RIO DOCE - DEMAIS INIICIATIVAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15235"
    }
  }, [_vm._v("15235 / RM FBB BNDES RIO DOCE - DEMAIS INICIATIVAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14947"
    }
  }, [_vm._v("14947 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15476"
    }
  }, [_vm._v("15476 / RM FBB ÁGUA DE BEBER")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15561"
    }
  }, [_vm._v("15561 / PROJETO SUPERIOR - BB EDUCAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15571"
    }
  }, [_vm._v("15571 / INCLUSãO DIGITAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15557"
    }
  }, [_vm._v("15557 / AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15579"
    }
  }, [_vm._v("15579 / INDEP. EDUCA RIO DOCE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15586"
    }
  }, [_vm._v("15586 / Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15575"
    }
  }, [_vm._v("15575 / INDEPENDENTES EDUCAÇÃO - PIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15577"
    }
  }, [_vm._v("15577 / INDEP. EDUCAÇÃO - VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15581"
    }
  }, [_vm._v("15581 / INDEP EDUC RIO DOC PTAC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15591"
    }
  }, [_vm._v("15591 / MEMóRIA DOCUMENTAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15595"
    }
  }, [_vm._v("15595 / PROJETO MEMóRIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15599"
    }
  }, [_vm._v("15599 / INDEPENDENTES CULTURA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15932"
    }
  }, [_vm._v("15932 / PROJETOS INDEPENDENTES EM EDUCAÇÃO - FBB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16418"
    }
  }, [_vm._v("16418 / RM FBB BNDES ÁGUA DE PRODUÇÃO PTAC 06/2015")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16520"
    }
  }, [_vm._v("16520 / RM FBB BNDES ECOFORTE REDES FA 2014")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15565"
    }
  }, [_vm._v("15565 / BB EDUCAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15567"
    }
  }, [_vm._v("15567 / BB EDUCAR INTEGRAçãO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16967"
    }
  }, [_vm._v("16967 / RM FBB BNDES - Fundo Social PTAC 2011 - Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16969"
    }
  }, [_vm._v("16969 / RM FBB BNDES - Fundo Social PTAC 2012 - Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18126"
    }
  }, [_vm._v("18126 / RP APAGÃO AMAPÁ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18128"
    }
  }, [_vm._v("18128 / RC APADRINHE UM FUTURO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18132"
    }
  }, [_vm._v("18132 / RM FBB MUSEU DO IPIRANGA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18137"
    }
  }, [_vm._v("18137 / RM FBB PROSPECÇÃO DIRETA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18140"
    }
  }, [_vm._v("18140 / RM FBB PIS MEIO AMBIENTE E RENDA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18144"
    }
  }, [_vm._v("18144 / RM FBB PRÊMIO DE TECNOLOGIA SOCIAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18147"
    }
  }, [_vm._v("18147 / RM FBB/COMPENSA CERRADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18152"
    }
  }, [_vm._v("18152 / RP COVID-19")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18154"
    }
  }, [_vm._v("18154 / RC COVID-19 FBB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18157"
    }
  }, [_vm._v("18157 / RM FBB DESAFIO TRANSFORMA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18160"
    }
  }, [_vm._v("18160 / RM FBB AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18163"
    }
  }, [_vm._v("18163 / RM FBB INSTITUTO VOTORANTIM PTAC 01-2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18166"
    }
  }, [_vm._v("18166 / RP ENCHENTES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18169"
    }
  }, [_vm._v("18169 / RC ENCHENTES ACRE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18171"
    }
  }, [_vm._v("18171 / RC ENCHENTES MINAS GERAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18173"
    }
  }, [_vm._v("18173 / RC COVID19-CNM PRATO CHEIO 2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18182"
    }
  }, [_vm._v("18182 / RM FBB VOLUNTARIADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18185"
    }
  }, [_vm._v("18185 / RM FBB ACORDO SUZANO PTAC 01/2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18188"
    }
  }, [_vm._v("18188 / RM FBB BNDES FS PTAC 2012 - REAPLICAÇÃO DE TS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18190"
    }
  }, [_vm._v("18190 / RM FBB BNDES FS PTAC 2013 - REAPLICAÇÃO DE TS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18192"
    }
  }, [_vm._v("18192 / RC COVID 19 GOVERNO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18195"
    }
  }, [_vm._v("18195 / RM FBB OUTROS PROJETOS DO PROGRAMA MEIO AMBIENTE E RENDA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18219"
    }
  }, [_vm._v("18219 / RM FBB BNDES OUTROS PROJETOS DE MEIO AMBIENTE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20030"
    }
  }, [_vm._v("20030 / RP CICLONE BOMBA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20039"
    }
  }, [_vm._v("20039 / RC COVID19 MUNICÍPIOS PRATO CHEIO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20241"
    }
  }, [_vm._v("20241 / RECUPERA CERRADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20260"
    }
  }, [_vm._v("20260 / RT MMFDH - SOLIDARIZE-SE")])]), _vm._v(" "), (_vm.errors.first('Projeto Duplicação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Projeto Duplicação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Eixo de Atuação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('eixo de atuação')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_categ_campo_atuacao),
      expression: "fep.ds_categ_campo_atuacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "eixo de atuação",
      "aria-hidden": "true",
      "aria-required": "true",
      "aria-invalid": "false"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "ds_categ_campo_atuacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Assistência a comunidades urbano-rurais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Assistência Social")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Ciência e Tecnologia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Cultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Educação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Recreação e Desporto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Saúde")])]), _vm._v(" "), (_vm.errors.first('eixo de atuação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('eixo de atuação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Programa")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('programa')
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_fep_programa),
      expression: "fep.ds_fep_programa"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "programa",
      "aria-hidden": "true",
      "aria-required": "true",
      "aria-invalid": "false"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "ds_fep_programa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("AABB Comunidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("BB Educar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Inclusão Digital")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Memória Documental")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Projeto Memória")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Reaplicação de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Trabalho e Cidadania")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Independentes - Assist. a comun. urbano-rurais")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Independentes - Assistência Social")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Independentes - Ciência e Tecnologia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Independentes - Cultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("Independentes - Educação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Independentes - Recreação e Desporto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Independentes - Saúde")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Ajuda Humanitária")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("Meio Ambiente e Renda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("Voluntariado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("Demais Iniciativas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Tecnologia Social")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("Educação para Futuro")])]), _vm._v(" "), (_vm.errors.first('programa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('programa')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Ação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Ação')
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_categ_acao),
      expression: "fep.ds_categ_acao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Ação",
      "aria-hidden": "true",
      "aria-required": "true",
      "aria-invalid": "false"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "ds_categ_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Água de Produção")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Água Brasil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("DRS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Voluntariado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Cataforte III - Escritório")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Cataforte I")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Cataforte II - Caminhões")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Cataforte III - Bases")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Ecoforte Redes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Terra Forte")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Prêmio TS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("Outros Projetos Água")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Ecoforte Extrativismo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Municípios Verdes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Outros Projetos Agroecologia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("Juventude Rural")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("Outros Projetos Agroindústria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("Outros Projetos Resíduos Sólidos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Outras Iniciativas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("PNHU")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("Cisternas Avaliação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("PIS-BB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("Rio Doce")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("Outros Projetos Educação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "26"
    }
  }, [_vm._v("Água de Beber")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "27"
    }
  }, [_vm._v("AABB Comunidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "28"
    }
  }, [_vm._v("BB Educar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "29"
    }
  }, [_vm._v("BB Educar Integração")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Inclusão Digital")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("Acordo Ministério da Defesa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("Fatores Climáticos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "33"
    }
  }, [_vm._v("pandemias e Epidemias")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "34"
    }
  }, [_vm._v("Aluízio Campos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "35"
    }
  }, [_vm._v("Museu do Ipiranga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "36"
    }
  }, [_vm._v("PIS - Novo Voluntariado - 2 sem")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "37"
    }
  }, [_vm._v("Suzano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "38"
    }
  }, [_vm._v("Vale Pará")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "39"
    }
  }, [_vm._v("Voluntariado 2020 a 2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("Prospecção Direta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("Hospital de Jaú")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "42"
    }
  }, [_vm._v("Desafio Transforma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "43"
    }
  }, [_vm._v("Enel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "44"
    }
  }, [_vm._v("Prêmio TS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("Votorantim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "46"
    }
  }, [_vm._v("AABB Comunidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "47"
    }
  }, [_vm._v("AVSI - Vozes Daqui")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v("Cisternas-Escolas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v("Compensa Cerrado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("Profesp")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("Reaplicação de TS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "52"
    }
  }, [_vm._v("Outros Projetos Educação para o Futuro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "53"
    }
  }, [_vm._v("Outros Projetos Meio Ambiente e Renda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "54"
    }
  }, [_vm._v("Outros Projetos Voluntariado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "55"
    }
  }, [_vm._v("Projetos Estruturantes Arrecadação Solidária-Covid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não se aplica")])]), _vm._v(" "), (_vm.errors.first('Ação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Ação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Parceria Estratégica (Vínculo)")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Parceria Estratégica')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.parc_estrategica),
      expression: "fep.parc_estrategica"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Parceria Estratégica",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "parc_estrategica", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2009 - 5.585-9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2010 - 55.805-2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2011 - 55.807-9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2012 - 55.808-7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2013 - 55.813-3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("BNDES - 10.2.2029.1/2010 - CATAFORTE II - 55.806-0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("PETROBRAS - 6000.0063847.10.4/2010 - CATAFORTE II - 402002-2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("BID/FUMIN - 11818/2010 - 405.320-6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("MTE/SENAES - 03/2007 - CATAFORTE I E II - 405.319-2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("WESTERN UNION - 405.400-8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("BNDES - 12.2.0435.1/2012 - FA/CONTRATO 2012 - 55.809-5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("BNDES - 12.2.0435.1/2012 - FA/CONTRATO 2014 - 55.812-5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("BNDES - 13.2.0505.1/2013 - ÁGUA DE PRODUÇÃO - 55.811-7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("BNDES - 13.2.0047.1/2013 - TERRAFORTE 2013 - 55.810-9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("MTE/SENAES - 795775/2013 - CATAFORTE III - 6.551-X")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("BNDES - 13.2.0047.1/2013 - TERRAFORTE 2014 - 55.814-1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("BNDES - 15.2.0773.1/2015 - FS/PTAC 06/2015 - 55.816-8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("INSTITUTO VOTORANTIM - PTAC 2018 - 55.823-0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("COPASA - 18.1247 - PROGRAMA PRO-MANANCIAIS - 55.820-6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "85"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - ACTF FBB-BOLDRINI 01/2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "86"
    }
  }, [_vm._v("DOAÇÃO COND ESPÓLIO ALUÍSIO A CAMPOS 00101236520028150011")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "87"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - AÇÃO COVID19-GOVERN - NT PORT 2020/0154")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "88"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - AÇÃO COVID 19 - NT PORT 2020/0154")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "89"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - OPERAÇÃO ACOLHIDA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - CÃO GUIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "91"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - MEIO AMBIENTE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - EDUCAÇÃO INCLUSIVA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "93"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - ENCHENTES RIO DE JANEIRO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "94"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - ENCHENTES MINAS GERAIS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "95"
    }
  }, [_vm._v("DOAÇÃO CONDICIONAL - ENCHENTES ESPÍRITO SANTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "96"
    }
  }, [_vm._v("BB - BÔNUS AMBIENTAL - ISD - 402.248-3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "97"
    }
  }, [_vm._v("BRASILCAP - TÍT. DE CAP. - ISD - 402.248-3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "98"
    }
  }, [_vm._v("Desvinculado de parceria por ato decisório")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("Não vinculado a parcerias")])]), _vm._v(" "), (_vm.errors.first('Parceria Estratégica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria Estratégica')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Tipo de Ação')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_fep_tipo_acao),
      expression: "fep.ds_fep_tipo_acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "ds_fep_tipo_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tiposAcao), function(i) {
    return _c('option', {
      domProps: {
        "value": i.code
      }
    }, [_vm._v(_vm._s(i.description))])
  }), 0), _vm._v(" "), (_vm.errors.first('Tipo de Ação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tipo de Ação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Abrangência')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.abrangencia),
      expression: "fep.abrangencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Abrangência",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.fep.abrangencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "abrangencia", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Abrangência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Abrangência')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v(" Participantes Diretos")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Participantes Diretos')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.publico_alvo),
      expression: "fep.publico_alvo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Participantes Diretos"
    },
    domProps: {
      "value": (_vm.fep.publico_alvo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "publico_alvo", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Participantes Diretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Participantes Diretos')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Prospecção")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Prospecção')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_categ_prospeccao),
      expression: "fep.ds_categ_prospeccao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Prospecção",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.fep.ds_categ_prospeccao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "ds_categ_prospeccao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Prospecção')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Prospecção')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Se Seleção, Nº/Nome Processo")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Processo')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_categ_edital),
      expression: "fep.ds_categ_edital"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Processo",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.fep.ds_categ_edital)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "ds_categ_edital", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Processo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Processo')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho required-fep"
  }, [_vm._v("Cadeia Produtiva")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Cadeia Produtiva')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_categ_vetor),
      expression: "fep.ds_categ_vetor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cadeia Produtiva",
      "aria-hidden": "true",
      "aria-required": "true",
      "aria-invalid": "false"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fep, "ds_categ_vetor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apicultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Avicultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Bovinocultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Cafeicultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Cajucultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Floricultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Mandiocultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Ovinocapricultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Psicultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Suinocultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Resíduos Sólidos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Artesanato")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("Fruticultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Turismo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Recuperação Ambiental")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Assistência Técnica")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("Capacitação e Formação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("Comunicação / Mobilização")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("Articulação e Redes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Horticultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("Silvicultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("Olericultura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não se aplica")])]), _vm._v(" "), (_vm.errors.first('Cadeia Produtiva')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cadeia Produtiva')))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped orcamento"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "required-fep"
  }, [_vm._v("Próprios FBB")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('total fbb')
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "total fbb",
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.fep.total_fbb),
      callback: function($$v) {
        _vm.$set(_vm.fep, "total_fbb", $$v)
      },
      expression: "fep.total_fbb"
    }
  }), _vm._v(" "), (_vm.errors.first('total fbb')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('total fbb')))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.fep.total_fbb / (_vm.fep.total_contrapartida + _vm.fep.total_fbb +
    _vm.fep.total_parceiro))) + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "required-fep"
  }, [_vm._v("Terceiros - Parcerias Estratégicas")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('total parceiro')
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "total parceiro",
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.fep.total_parceiro),
      callback: function($$v) {
        _vm.$set(_vm.fep, "total_parceiro", $$v)
      },
      expression: "fep.total_parceiro"
    }
  }), _vm._v(" "), (_vm.errors.first('total parceiro')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('total parceiro')))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.fep.total_parceiro / (_vm.fep.total_contrapartida + _vm.fep.total_fbb +
    _vm.fep.total_parceiro))) + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "required-fep"
  }, [_vm._v("Contrapartida - Proponente")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "total_contrapartida",
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.fep.total_contrapartida),
      callback: function($$v) {
        _vm.$set(_vm.fep, "total_contrapartida", $$v)
      },
      expression: "fep.total_contrapartida"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.fep.total_contrapartida / (_vm.fep.total_contrapartida + _vm.fep.total_fbb +
    _vm.fep.total_parceiro))) + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.fep.total_contrapartida + _vm.fep.total_fbb + _vm.fep.total_parceiro)) + "\n                      ")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.fep.total_contrapartida + _vm.fep.total_fbb + _vm.fep.total_parceiro) /
    (_vm.fep.total_contrapartida + _vm.fep.total_fbb + _vm.fep.total_parceiro))) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.ds_fep_observacao),
      expression: "fep.ds_fep_observacao"
    }, {
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_fep_observacao"
    },
    domProps: {
      "value": (_vm.fep.ds_fep_observacao)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "ds_fep_observacao", $event.target.value)
      }, _vm.resizable]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "bloco"
  }, [_c('tr', [_c('td', [_c('textarea', {
    staticClass: "form-control"
  }, [_vm._v("Enquadramento validado em " + _vm._s(_vm.hoje))])])]), _vm._v(" "), _vm._m(7)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "float"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Dados do Projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Enquadramento na Árvore de Projetos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Orçamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Recursos")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("% Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Observações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Enquadramento Orçamentário")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('div', {
    staticClass: "assinatura"
  }, [_c('span', [_vm._v("Assessor Formalização - Orçamento")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b5625d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/relatorioFepAberto.vue
// module id = 1785
// module chunks = 2